<template>
  <el-container  style="display: block;">

    <el-row   style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-input placeholder="请输入密码" style="width: 70%;" v-model="password">

          </el-input>

      </el-row>
      <el-row :span="20" style="margin-top: 30px;text-align: center;width: 70%;">

          <el-button type="primary" style="background-color: #409eff;" @click="down()" round>下载</el-button>
      </el-row>
     </el-row>

  </el-container>
</template>

<script>
  import CryptoJS from 'crypto-js';
  export default {
    data() {
       return {
         disfangxiang:false,
         id:this.$route.query.id,
         password:'',



      }
    },
  directives: {
    },
    created() {



    },

  methods:{
    down(){
      // console.log(this.id)
      // console.log(this.decryptData(this.id.replace(' ','+')))
      const id = this.decryptData(this.id.replace(' ','+'))
      this.downs(id)
    },
    downs(id){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id,
          name:this.password
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/checks'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.madeCode(res.data.data)
        }else{
          this.msg(res.data.data,'error')
        }
        // const did = res.data.data
        // const dids = this.encryptData(did)
        // this.setUrl(did,dids)
      })
      .catch(err=>{

      });
    },
    getUrl(accessKeyId,accessKeySecret,stsToken,name){

      const client = new OSS({
              // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: "oss-cn-shenzhen",
        accessKeyId: accessKeyId,
        accessKeySecret: accessKeySecret,
        stsToken: stsToken,
        bucket: "yuzhouzhimi-test",
      });

            // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
      const filename = name;
      const response = {
        "content-disposition": `attachment; filename=${encodeURIComponent(
          filename
        )}`,
      };
            // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
      const url = client.signatureUrl(filename, { response });
      const urls = url.replace('yuzhouzhimi-test.oss-cn-shenzhen.aliyuncs.com','bucket.yoooooo.com')
      // return urls
      //本页下载代码
      const link = document.createElement('a');
      link.href = urls;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    },
    madeCode(filename){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/ossTest'
      })
      .then(res=>{
        const cc = res.data.data
        // console.log(cc);
        const urls = this.getUrl(cc.AccessKeyId,cc.AccessKeySecret,cc.SecurityToken,filename)
        this.generateQRCode(urls)

      })
      .catch(err=>{

      });
    },
    decryptData(encryptedData) {
      const secretKey = 'uoag2m67hyhk458ascasg'; // 替换为你的密钥
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return originalData;
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/down.vue